export default function P32PayrollView({ data, preview_url }) {
  return (
    <div className="mt-6 space-y-6">

      <div className="bg-[#1d5aa9] p-4 rounded-lg ">
        <h2 className="text-xl font-semibold">P32 Payroll Summary</h2>
      </div>

      <div className="bg-white border rounded-lg shadow">
        <table className="w-full text-sm">
          <tbody>
            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">Client Name</td>
              <td className="p-3">{data.client_name}</td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">Tax Period</td>
              <td className="p-3">{data.tax_period}</td>
            </tr>

            <tr className="border-b">
              <td className="p-3 font-medium bg-gray-50">Processing Status</td>
              <td className="p-3">{data.processing_status}</td>
            </tr>

            <tr>
              <td className="p-3 font-medium bg-gray-50">Filename</td>
              <td className="p-3">{data.filename}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {preview_url && (
        <iframe
       width="100%"
            height="600"
          src={preview_url}
          className="w-full h-[600px] border rounded-lg"
          title="P32 Payroll Preview"
        />
      )}
    </div>
  );
}
